const apiUrl = process.env.REACT_APP_API_URL;

export const uploadItemFiles = async (itemId, files, folioId = null) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/files/uploadFiles/${itemId}`;
    const formData = new FormData();

    Array.from(files).forEach(file => {
        formData.append('files', file);
    });

    if (folioId) {
        formData.append('folioId', folioId);
    }

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
        body: formData
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        console.error('Error al subir archivos:', error);
        return { result: false };
    }
};

export const getItemAttachments = async (itemId, folioId = null) => {
    const token = sessionStorage.getItem('token');
    const qs = folioId ? `?folioId=${folioId}` : '';
    const url = `${apiUrl}/api/files/getAttachments/${itemId}${qs}`;

    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        }
    };

    try {
        const response = await fetch(url, requestOptions);
        const data = await response.json();

        if (data.result && Array.isArray(data.data)) return data.data;
        if (Array.isArray(data)) return data;

        return [];
    } catch (error) {
        console.error('Error al obtener archivos:', error);
        return [];
    }
};

export const getEvidenceSummaryByItems = async (itemIds) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/files/getEvidenceSummaryByItems`;

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ itemIds }),
    };

    try {
        const response = await fetch(url, requestOptions);
        const data = await response.json();
        return data?.data || [];
    } catch (error) {
        console.error('Error al obtener resumen de evidencia:', error);
        return [];
    }
};

export const deleteAttachment = async (attachmentId) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/files/deleteAttachment/${attachmentId}`;

    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        }
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        console.error('Error al eliminar archivo:', error);
        return { result: false };
    }
};